import React from 'react'
import {Link} from 'react-router-dom'

import routesHelper from '@prepler/core/lib/routesHelper'

import sports from './sports'
import Helmet from '../common/helmet'
import TitledTab from '../common/titledTab'
import BlogPosts from '../blogPosts'
import useStyles from './styles'

const SportsItem = () => {
	const classes = useStyles();

	return (
		<>
			<Helmet
				title="College Sports"
				description="TBD"
			/>
			<div className={classes.container}>
				<TitledTab title="College Sports">
					<div className={classes.description}>
						{/*<h2 className={classes.h2}>College Sports</h2>*/}
						<p>
							{/*Explore the {(new Date()).getFullYear()} top-ranked colleges in each state across the U.S. to find a good one near you.*/}
						</p>
						<div className={classes.columns}>
							{sports.map(({name, id}) => (
								<Link to={routesHelper.sportPath({id})}>{name}</Link>
							))}
						</div>
					</div>
				</TitledTab>
				<div className={classes.sidebar}>
					<BlogPosts slug="sports"/>
				</div>
			</div>
		</>
	);
}

export default SportsItem;
